//TODO: Seperate into Home, Contracts and Reports Actios/Reducer
export const GET_QUALIFICATION_YEARS = 'GET_QUALIFICATION_YEARS';
export const UPDATE_ACTIVE_QUALIFICATION_YEAR = 'UPDATED_SELECTED_QUALIFICATION_YEAR';
export const GET_DISAPLAY_STATUS = 'GET_DISPLAY_STATUS';
export const GET_APPOINTMENT_TYPES = 'GET_APPOINTMENT_TYPES';
export const UPDATED_GROUPING_AND_TYPES = 'UPDATED_GROUPING_AND_TYPES';
export const CONTRACT_GLOBALS_ERROR = 'CONTRACT_GLOBALS_ERROR';
export const AUTH_ERROR = 'AUTH_ERROR';
export const ADD_TOAST_MESSAGE = 'ADD_TOAST_MESSAGE';
export const CLEAR_TOAST_MESSAGE = 'CLEAR_TOAST_MESSAGE';
export const UPDATE_REFINER_SELECTORS = 'UPDATE_REFINER_SELECTORS';